import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DictionaryItem, SelectComponent, StrNum } from '@hglobal/fin-ui';
import { FormControl } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { CurrencyBalanceFormatPipe, ProviderTypePipe } from '@kr/pipes';

@Component({
  selector: 'kr-total-balance',
  imports: [SelectComponent, TranslateModule, CurrencyBalanceFormatPipe, ProviderTypePipe],
  templateUrl: './total-balance.component.html',
  styleUrl: './total-balance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalBalanceComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);

  selectedCurrency = 1; // By default 1 (USDT)
  providerType = input.required<string>();
  currencies = input.required<DictionaryItem<StrNum>[]>();
  balance = input.required<string>();
  currencyChange = output<number>();

  currencyControl = new FormControl(this.selectedCurrency);
  loading = signal(false);

  balanceChangeEffect = effect(() => {
    this.balance();
    this.loading.set(false);
  });

  get currencySymbol(): string {
    const currency = this.currencies().find(c => c.id === this.currencyControl.value);
    return currency?.name ?? '';
  }

  ngOnInit(): void {
    this.currencyControl.valueChanges
      .pipe(
        filter(v => !!v),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(currencyId => {
        this.loading.set(true);
        this.currencyChange.emit(currencyId);
      });
  }
}
